/**
 * Do not edit directly
 * Generated on Tue, 27 May 2025 10:41:24 GMT
 */
export const globalFontWeightBold = "700";
export const globalFontWeightSemiBold = "600";
export const globalFontWeightRegular = "400";
export const globalGradientGray20 = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
export const globalGradientGray10 = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
export const globalGradientDeepOcean1 = "linear-gradient(132deg, #29333D 0%, #001C33 100%);";
export const globalChartCoast30 = "hsl(202, 100%, 30%)";
export const globalChartCoast40 = "hsl(202, 100%, 40%)";
export const globalChartMermaid23 = "hsl(169, 82%, 23%)";
export const globalChartMermaid33 = "hsl(169, 82%, 33%)";
export const globalChartBrine33 = "hsl(346, 37%, 33%)";
export const globalChartBrine43 = "hsl(346, 37%, 43%)";
export const globalChartSeaglass17 = "hsl(151, 46%, 17%)";
export const globalChartSeaglass27 = "hsl(151, 46%, 27%)";
export const globalChartJellyfish35 = "hsl(266, 63%, 35%)";
export const globalChartJellyfish45 = "hsl(266, 63%, 45%)";
export const globalChartAnemone30 = "hsl(36, 77%, 30%)";
export const globalChartAnemone40 = "hsl(36, 77%, 40%)";
export const globalChartSunset60 = "hsl(36, 97%, 60%)";
export const globalChartSunset70 = "hsl(36, 97%, 70%)";
export const globalChartLionfish65 = "hsl(301, 73%, 65%)";
export const globalChartLionfish75 = "hsl(301, 73%, 75%)";
export const globalOrange10 = "hsl(30, 70%, 10%)";
export const globalOrange20 = "hsl(30, 70%, 20%)";
export const globalOrange30 = "hsl(30, 70%, 30%)";
export const globalOrange40 = "hsl(30, 70%, 40%)";
export const globalOrange50 = "hsl(30, 70%, 50%)";
export const globalOrange60 = "hsl(30, 70%, 60%)";
export const globalOrange70 = "hsl(30, 70%, 70%)";
export const globalOrange82 = "hsl(30, 70%, 82%)";
export const globalOrange86 = "hsl(30, 70%, 86%)";
export const globalOrange88 = "hsl(30, 70%, 88%)";
export const globalOrange90 = "hsl(30, 70%, 90%)";
export const globalOrange92 = "hsl(30, 70%, 92%)";
export const globalOrange96 = "hsl(30, 70%, 96%)";
export const globalOrange98 = "hsl(30, 70%, 98%)";
export const globalGreen10 = "hsl(150, 50%, 10%)";
export const globalGreen20 = "hsl(150, 50%, 20%)";
export const globalGreen30 = "hsl(150, 50%, 30%)";
export const globalGreen40 = "hsl(150, 50%, 40%)";
export const globalGreen50 = "hsl(150, 50%, 50%)";
export const globalGreen60 = "hsl(150, 50%, 60%)";
export const globalGreen70 = "hsl(150, 50%, 70%)";
export const globalGreen82 = "hsl(150, 50%, 82%)";
export const globalGreen86 = "hsl(150, 50%, 86%)";
export const globalGreen88 = "hsl(150, 50%, 88%)";
export const globalGreen90 = "hsl(150, 50%, 90%)";
export const globalGreen92 = "hsl(150, 50%, 92%)";
export const globalGreen96 = "hsl(150, 50%, 96%)";
export const globalGreen98 = "hsl(150, 50%, 98%)";
export const globalRed10 = "hsl(350, 70%, 10%)";
export const globalRed20 = "hsl(350, 70%, 20%)";
export const globalRed30 = "hsl(350, 70%, 30%)";
export const globalRed40 = "hsl(350, 70%, 40%)";
export const globalRed50 = "hsl(350, 70%, 50%)";
export const globalRed60 = "hsl(350, 70%, 60%)";
export const globalRed70 = "hsl(350, 70%, 70%)";
export const globalRed82 = "hsl(350, 70%, 82%)";
export const globalRed86 = "hsl(350, 70%, 86%)";
export const globalRed88 = "hsl(350, 70%, 88%)";
export const globalRed90 = "hsl(350, 70%, 90%)";
export const globalRed92 = "hsl(350, 70%, 92%)";
export const globalRed96 = "hsl(350, 70%, 96%)";
export const globalRed98 = "hsl(350, 70%, 98%)";
export const globalYellow10 = "hsl(50, 70%, 10%)";
export const globalYellow20 = "hsl(50, 70%, 20%)";
export const globalYellow30 = "hsl(50, 70%, 30%)";
export const globalYellow40 = "hsl(50, 70%, 40%)";
export const globalYellow50 = "hsl(50, 70%, 50%)";
export const globalYellow60 = "hsl(50, 70%, 60%)";
export const globalYellow70 = "hsl(50, 70%, 70%)";
export const globalYellow82 = "hsl(50, 70%, 82%)";
export const globalYellow86 = "hsl(50, 70%, 86%)";
export const globalYellow88 = "hsl(50, 70%, 88%)";
export const globalYellow90 = "hsl(50, 70%, 90%)";
export const globalYellow92 = "hsl(50, 70%, 92%)";
export const globalYellow96 = "hsl(50, 70%, 96%)";
export const globalYellow98 = "hsl(50, 70%, 98%)";
export const globalViolet10 = "hsl(270, 50%, 10%)";
export const globalViolet20 = "hsl(270, 50%, 20%)";
export const globalViolet30 = "hsl(270, 50%, 30%)";
export const globalViolet40 = "hsl(270, 50%, 40%)";
export const globalViolet50 = "hsl(270, 50%, 50%)";
export const globalViolet60 = "hsl(270, 50%, 60%)";
export const globalViolet70 = "hsl(270, 50%, 70%)";
export const globalViolet82 = "hsl(270, 50%, 82%)";
export const globalViolet86 = "hsl(270, 50%, 86%)";
export const globalViolet88 = "hsl(270, 50%, 88%)";
export const globalViolet90 = "hsl(270, 50%, 90%)";
export const globalViolet92 = "hsl(270, 50%, 92%)";
export const globalViolet96 = "hsl(270, 50%, 96%)";
export const globalViolet98 = "hsl(270, 50%, 98%)";
export const globalDeepOcean10 = "hsl(210, 20%, 10%)";
export const globalDeepOcean20 = "hsl(210, 20%, 20%)";
export const globalDeepOcean30 = "hsl(210, 20%, 30%)";
export const globalDeepOcean40 = "hsl(210, 20%, 40%)";
export const globalDeepOcean50 = "hsl(210, 20%, 50%)";
export const globalDeepOcean60 = "hsl(210, 20%, 60%)";
export const globalDeepOcean70 = "hsl(210, 20%, 70%)";
export const globalDeepOcean82 = "hsl(210, 20%, 82%)";
export const globalDeepOcean86 = "hsl(210, 20%, 86%)";
export const globalDeepOcean88 = "hsl(210, 20%, 88%)";
export const globalDeepOcean90 = "hsl(210, 20%, 90%)";
export const globalDeepOcean92 = "hsl(210, 20%, 92%)";
export const globalDeepOcean96 = "hsl(210, 20%, 96%)";
export const globalDeepOcean98 = "hsl(210, 20%, 98%)";
export const globalBlue10 = "#001c33";
export const globalBlue20 = "hsl(207, 100%, 20%)";
export const globalBlue30 = "hsl(207, 100%, 30%)";
export const globalBlue40 = "hsl(207, 100%, 40%)";
export const globalBlue50 = "hsl(207, 100%, 50%)";
export const globalBlue60 = "hsl(207, 100%, 60%)";
export const globalBlue70 = "hsl(207, 100%, 70%)";
export const globalBlue82 = "hsl(207, 100%, 82%)";
export const globalBlue86 = "hsl(207, 100%, 86%)";
export const globalBlue88 = "hsl(207, 100%, 88%)";
export const globalBlue90 = "hsl(207, 100%, 90%)";
export const globalBlue92 = "hsl(207, 100%, 92%)";
export const globalBlue96 = "hsl(207, 100%, 96%)";
export const globalBlue98 = "hsl(207, 100%, 98%)";
export const globalBlueGray10 = "hsl(200, 30%, 10%)";
export const globalBlueGray20 = "hsl(200, 30%, 20%)";
export const globalBlueGray30 = "hsl(200, 30%, 30%)";
export const globalBlueGray40 = "hsl(200, 30%, 40%)";
export const globalBlueGray50 = "hsl(200, 30%, 50%)";
export const globalBlueGray60 = "hsl(200, 30%, 60%)";
export const globalBlueGray70 = "hsl(200, 30%, 70%)";
export const globalBlueGray82 = "hsl(200, 30%, 82%)";
export const globalBlueGray86 = "hsl(200, 30%, 86%)";
export const globalBlueGray88 = "hsl(200, 30%, 88%)";
export const globalBlueGray90 = "hsl(200, 30%, 90%)";
export const globalBlueGray92 = "hsl(200, 30%, 92%)";
export const globalBlueGray96 = "hsl(200, 30%, 96%)";
export const globalBlueGray98 = "hsl(200, 30%, 98%)";
export const globalWhite = "#ffffff";
export const globalBoxShadow1 = "0 5px 12px 2px rgba(0,0,0,0.11)";
export const globalBoxShadow2 = "0 10px 20px 0 rgba(0,0,0,0.2)";
export const globalBoxShadow3 = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const globalBoxShadowNone = "0 0 0 0 hsl(200, 30%, 86%)";
export const globalBoxShadowFlat = "0 1px 0 0 #F0F3FA";
export const globalBoxShadow2Top = "0 -8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
export const globalFontFamiliesManrope = "Manrope";
export const globalFontFamiliesSanchez = "Sanchez";
export const globalFontFamiliesRoboto = "Roboto";
export const globalFontFamiliesWireframes = "'Sometype Mono'";
export const globalLineHeights6 = "6px";
export const globalLineHeights8 = "8px";
export const globalLineHeights10 = "10px";
export const globalLineHeights12 = "12px";
export const globalLineHeights14 = "14px";
export const globalLineHeights16 = "16px";
export const globalLineHeights18 = "18px";
export const globalLineHeights20 = "20px";
export const globalLineHeights22 = "22px";
export const globalLineHeights24 = "24px";
export const globalLineHeights26 = "26px";
export const globalLineHeights28 = "28px";
export const globalLineHeights30 = "30px";
export const globalLineHeights32 = "32px";
export const globalLineHeights48 = "48px";
export const globalLineHeightsPercentage125 = 1.25;
export const globalBorderRadius0 = "0px";
export const globalBorderRadius2 = "2px";
export const globalBorderRadius4 = "4px";
export const globalBorderRadius100 = "100px";
export const globalSize1 = "4px";
export const globalSize2 = "8px";
export const globalSize3 = "12px";
export const globalSize4 = "16px";
export const globalSize5 = "20px";
export const globalSize6 = "24px";
export const globalSize7 = "28px";
export const globalSize8 = "32px";
export const globalSize9 = "36px";
export const globalSize10 = "40px";
export const globalSize11 = "44px";
export const globalSize12 = "48px";
export const globalSize13 = "52px";
export const globalSize14 = "56px";
export const globalSize17 = "68px";
export const globalSize44 = "176px";
export const globalSize69 = "276px";
export const globalSize75 = "300px";
export const globalSize94 = "376px";
export const globalSize106 = "424px";
export const globalSize144 = "576px";
export const globalSize194 = "776px";
export const globalSize208 = "832px";
export const globalSize320 = "1280px";
export const globalSizeHalf = "2px";
export const globalSpace0 = "0px";
export const globalSpace1 = "4px";
export const globalSpace2 = "8px";
export const globalSpace3 = "12px";
export const globalSpace4 = "16px";
export const globalSpace5 = "20px";
export const globalSpace6 = "24px";
export const globalSpace7 = "28px";
export const globalSpace8 = "32px";
export const globalSpace9 = "36px";
export const globalSpace10 = "40px";
export const globalSpace11 = "44px";
export const globalSpace12 = "48px";
export const globalSpace13 = "52px";
export const globalSpace14 = "56px";
export const globalSpace15 = "60px";
export const globalSpace16 = "64px";
export const globalSpaceHalf = "2px";
export const globalFontSize6 = "6px";
export const globalFontSize8 = "8px";
export const globalFontSize10 = "10px";
export const globalFontSize12 = "12px";
export const globalFontSize14 = "14px";
export const globalFontSize16 = "16px";
export const globalFontSize20 = "20px";
export const globalFontSize24 = "24px";
export const globalFontSize30 = "30px";
export const globalFontSize40 = "40px";
export const globalFontSize50 = "50px";
export const globalFontSize60 = "60px";
export const globalFontSize70 = "70px";
export const globalLetterSpacing0 = "0";
export const globalTextCaseNone = "none";
export const globalTextDecorationNone = "none";
export const globalTextDecorationUnderline = "underline";
export const globalBorderWidth0 = "0px";
export const globalBorderWidth1 = "1px";
export const globalBorderWidth2 = "2px";
export const globalTeal10 = "#082b25";
export const globalTeal20 = "#0f574b";
export const globalTeal30 = "#178270";
export const globalTeal40 = "#1fad96";
export const globalTeal50 = "#26d9bb";
export const globalTeal60 = "#52e0c9";
export const globalTeal70 = "#7de8d6";
export const globalTeal80 = "#a8f0e4";
export const globalTeal90 = "#d4f7f1";
export const globalLavendar10 = "#0f1624";
export const globalLavendar20 = "#1f2c47";
export const globalLavendar30 = "#2e426b";
export const globalLavendar40 = "#3d588f";
export const globalLavendar50 = "#4d6fb3";
export const globalLavendar60 = "#708bc2";
export const globalLavendar70 = "#94a8d1";
export const globalLavendar80 = "#b8c5e0";
export const globalLavendar90 = "#dbe2f0";
export const globalLavendar92 = "#e2e8f3";
export const globalFushia10 = "#260d26";
export const globalFushia20 = "#4d1a4d";
export const globalFushia30 = "#732673";
export const globalFushia40 = "#939";
export const globalFushia50 = "#bf40bf";
export const globalFushia60 = "#c6c";
export const globalFushia70 = "#d98cd9";
export const globalFushia80 = "#e6b3e6";
export const globalFushia90 = "#f2d9f2";
export const muiTeal15 = "#F3FDFE";
export const muiTeal25 = "#E7FBFE";
export const muiTeal50 = "#CEF6FD";
export const muiTeal100 = "#9EEDFC";
export const muiTeal400 = "#00B5D1";
export const muiTeal500 = "#0F98AE";
export const muiTeal600 = "#147A8B";
export const muiTeal700 = "#105B69";
export const muiTeal800 = "#073C46";
export const muiTeal900 = "#011D23";
export const muiLavendar100 = "#EDE3F6";
export const muiLavendar200 = "#D9C8E5";
export const muiLavendar300 = "#C6ACD4";
export const muiLavendar400 = "#B390C3";
export const muiLavendar500 = "#A273B2";
export const muiLavendar600 = "#9253A1";
export const muiLavendar700 = "#643479";
export const muiLavendar800 = "#3A1750";
export const muiLavendar900 = "#160428";
export const muiFushia100 = "#FFD8F6";
export const muiFushia200 = "#FCB7E5";
export const muiFushia300 = "#F396D4";
export const muiFushia400 = "#E974C2";
export const muiFushia500 = "#E04FAF";
export const muiFushia600 = "#D6269B";
export const muiFushia700 = "#A11C74";
export const muiFushia800 = "#6B0D4C";
export const muiFushia900 = "#350124";
export const muiGreen50 = "#DBF6CA";
export const muiGreen500 = "#3B770E";
export const muiGreen900 = "#1D4405";
export const muiRed50 = "#FFEEEE";
export const muiRed500 = "#DE3131";
export const muiRed900 = "#6F1010";
export const muiRedOrange50 = "#F8ECE7";
export const muiRedOrange100 = "#FFDAC4";
export const muiRedOrange200 = "#FFB892";
export const muiRedOrange300 = "#FF9563";
export const muiRedOrange500 = "#DF5C24";
export const muiRedOrange900 = "#3A1404";
export const muiInfoGray50 = "#F0F3FA";
export const muiInfoGray500 = "#5E728D";
export const muiInfoGray900 = "#263146";
export const muiBlue50 = "#e5f4ff";
export const muiBlue500 = "#0070cc";
export const muiBlue700 = "#005499";
export const muiBlue800 = "#053C60";
export const muiBlue900 = "#001D30";
export const muiGray15 = "#FBFBFB";
export const muiGray20 = "#f5f5f5";
export const muiGray25 = "#F0F0EF";
export const muiGray50 = "#E2E2E1";
export const muiGray100 = "#C8C8C7";
export const muiGray200 = "#AFAFAE";
export const muiGray300 = "#AFAFAE";
export const muiGray400 = "#969695";
export const muiGray500 = "#7D7D7D";
export const muiGray600 = "#646464";
export const muiGray700 = "#4B4B4B";
export const muiGray800 = "#323232";
export const muiGray900 = "#191919";
export const aliasesBoxShadowDefault = "0 0 0 0 hsl(200, 30%, 86%)";
export const aliasesBoxShadowFloating = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const aliasesBoxShadowTop = "-8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
export const aliasesSizeMicro = "4px";
export const aliasesSizeXxs = "8px";
export const aliasesSizeXs = "12px";
export const aliasesSizeS = "16px";
export const aliasesSizeM = "20px";
export const aliasesSizeL = "24px";
export const aliasesSizeXl = "28px";
export const aliasesSizeXxl = "32px";
export const aliasesSizeInput = "36px";
export const aliasesSizeWidthColumn1 = "68px";
export const aliasesSizeWidthColumn2 = "176px";
export const aliasesSizeWidthColumn3 = "276px";
export const aliasesSizeWidthColumn4 = "376px";
export const aliasesSizeWidthColumn6 = "576px";
export const aliasesSizeWidthColumn8 = "776px";
export const aliasesSizeWidthDesktopDefault = "1280px";
export const aliasesSizeHeightInputDense = "36px";
export const aliasesSizeHeightDesktopDefault = "832px";
export const aliasesSizeComponentXxl = "56px";
export const aliasesSizeComponentXl = "44px";
export const aliasesSizeComponentM = "36px";
export const aliasesSizeParticle = "_global.size.half";
export const aliasesBorderWidthNone = "0px";
export const aliasesBorderWidthDefault = "1px";
export const aliasesBorderWidthThick = "2px";
export const aliasesLineHeightCta = "14px";
export const aliasesLineHeightAvatar = "24px";
export const aliasesLineHeightDefault = "16px";
export const aliasesLineHeightInput = "18px";
export const aliasesLineHeightCaption = "12px";
export const aliasesLineHeightMicro = "8px";
export const aliasesLineHeightLabel = "10px";
export const aliasesLineHeightH1 = "32px";
export const aliasesLineHeightH2 = "26px";
export const aliasesLineHeightH3 = "22px";
export const aliasesLineHeightH4 = "18px";
export const aliasesFontWeightDefault = "400";
export const aliasesFontWeightNeutral = "600";
export const aliasesFontWeightEmphasis = "700";
export const aliasesFontFamilyDefault = "Manrope";
export const aliasesFontFamilyHeader = "Sanchez";
export const aliasesFontFamilyPromo = "Manrope";
export const aliasesPromoFontSizeMicro = "10px";
export const aliasesPromoFontSizeCaption = "12px";
export const aliasesPromoFontSizeDefault = "16px";
export const aliasesPromoFontSizeH1 = "50px";
export const aliasesPromoFontSizeH2 = "40px";
export const aliasesPromoFontSizeH3 = "30px";
export const aliasesPromoFontSizeH4 = "20px";
export const aliasesPromoFontSizeDefaultSmall = "14px";
export const aliasesPromoFontWeightDefault = "400";
export const aliasesPromoFontWeightNeutral = "400";
export const aliasesPromoFontWeightEmphasis = "700";
export const aliasesPromoLineHeightDefault = 1.25;
export const aliasesSpaceContainerDefault = "16px";
export const aliasesSpaceContainerDense = "8px";
export const aliasesSpaceContainerSpacious = "24px";
export const aliasesSpaceComponentDefault = "8px";
export const aliasesSpaceComponentSpacious = "16px";
export const aliasesSpaceComponentDense = "4px";
export const aliasesSpaceComponentParticle = "_global.space.half";
export const aliasesBorderRadiusNone = "0px";
export const aliasesBorderRadiusSharp = "2px";
export const aliasesBorderRadiusDefault = "4px";
export const aliasesBorderRadiusRound = "100px";
export const aliasesColorBorderSeries1Default = "hsl(202, 100%, 40%)";
export const aliasesColorBorderSeries1Hover = "hsl(202, 100%, 30%)";
export const aliasesColorBorderSeries1Focus = "hsl(202, 100%, 30%)";
export const aliasesColorBorderSeries1Selected = "hsl(202, 100%, 30%)";
export const aliasesColorBorderSeries1Transparent = "hsl(202 100% 40% / 0.5)"; // Used for map pins
export const aliasesColorBorderSeries2Default = "hsl(266, 63%, 45%)";
export const aliasesColorBorderSeries2Hover = "hsl(266, 63%, 35%)";
export const aliasesColorBorderSeries2Focus = "hsl(266, 63%, 35%)";
export const aliasesColorBorderSeries2Selected = "hsl(266, 63%, 35%)";
export const aliasesColorBorderSeries2Transparent = "hsl(266 63% 45% / 0.5)";
export const aliasesColorBorderSeries3Default = "hsl(301, 73%, 75%)";
export const aliasesColorBorderSeries3Hover = "hsl(301, 73%, 65%)";
export const aliasesColorBorderSeries3Focus = "hsl(301, 73%, 65%)";
export const aliasesColorBorderSeries3Selected = "hsl(301, 73%, 65%)";
export const aliasesColorBorderSeries3Transparent = "hsl(301 73% 75% / 0.5)";
export const aliasesColorBorderSeries4Default = "hsl(169, 82%, 33%)";
export const aliasesColorBorderSeries4Hover = "hsl(169, 82%, 23%)";
export const aliasesColorBorderSeries4Focus = "hsl(169, 82%, 23%)";
export const aliasesColorBorderSeries4Selected = "hsl(169, 82%, 23%)";
export const aliasesColorBorderSeries4Transparent = "hsl(169 82% 33% / 0.5)";
export const aliasesColorBorderSeries5Default = "hsl(346, 37%, 43%)";
export const aliasesColorBorderSeries5Hover = "hsl(346, 37%, 33%)";
export const aliasesColorBorderSeries5Focus = "hsl(346, 37%, 33%)";
export const aliasesColorBorderSeries5Selected = "hsl(346, 37%, 33%)";
export const aliasesColorBorderSeries5Transparent = "hsl(346 37% 43% / 0.5)";
export const aliasesColorBorderSeries6Default = "hsl(36, 77%, 40%)";
export const aliasesColorBorderSeries6Hover = "hsl(36, 77%, 30%)";
export const aliasesColorBorderSeries6Focus = "hsl(36, 77%, 30%)";
export const aliasesColorBorderSeries6Selected = "hsl(36, 77%, 30%)";
export const aliasesColorBorderSeries6Transparent = "hsl(36 77% 40% / 0.5)";
export const aliasesColorBorderSeries7Default = "hsl(151, 46%, 17%)";
export const aliasesColorBorderSeries7Hover = "hsl(151, 46%, 27%)";
export const aliasesColorBorderSeries7Focus = "hsl(151, 46%, 27%)";
export const aliasesColorBorderSeries7Selected = "hsl(169, 82%, 23%)";
export const aliasesColorBorderSeries7Transparent = "hsl(151 46% 27% / 0.5)";
export const aliasesColorBorderSeries8Default = "hsl(36, 97%, 70%)";
export const aliasesColorBorderSeries8Hover = "hsl(36, 97%, 60%)";
export const aliasesColorBorderSeries8Focus = "hsl(36, 97%, 60%)";
export const aliasesColorBorderSeries8Selected = "hsl(36, 97%, 60%)";
export const aliasesColorBorderSeries8Transparent = "hsl(36 97% 70% / 0.5)";
export const aliasesColorBorderInteractiveComponentSubtleDefault = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveComponentSubtleHover = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveComponentSubtleFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentSubtleDisabled = "hsl(200 30% 82% / 0.38)";
export const aliasesColorBorderInteractiveComponentNeutralDefault = "hsl(200, 30%, 60%)";
export const aliasesColorBorderInteractiveComponentNeutralHover = "hsl(200, 30%, 60%)";
export const aliasesColorBorderInteractiveComponentNeutralFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentNeutralDisabled = "hsl(200 30% 60% / 0.38)";
export const aliasesColorBorderInteractiveComponentEmphasisDefault = "#001c33";
export const aliasesColorBorderInteractiveComponentEmphasisHover = "hsl(207, 100%, 20%)";
export const aliasesColorBorderInteractiveComponentEmphasisFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveComponentEmphasisDisabled = "hsl(207 100% 10% / 0.38)";
export const aliasesColorBorderInteractiveContainerSubtleDefault = "hsl(200, 30%, 96%)";
export const aliasesColorBorderInteractiveContainerSubtleHover = "hsl(200, 30%, 96%)";
export const aliasesColorBorderInteractiveContainerSubtleFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerSubtleDisabled = "hsl(200 30% 96% / 0.38)";
export const aliasesColorBorderInteractiveContainerSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerNeutralDefault = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveContainerNeutralHover = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveContainerNeutralFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerNeutralDisabled = "hsl(200 30% 82% / 0.38)";
export const aliasesColorBorderInteractiveContainerNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerEmphasisDefault = "hsl(200, 30%, 60%)";
export const aliasesColorBorderInteractiveContainerEmphasisHover = "hsl(200, 30%, 60%)";
export const aliasesColorBorderInteractiveContainerEmphasisFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerEmphasisDisabled = "hsl(200 30% 60% / 0.38)";
export const aliasesColorBorderInteractiveContainerEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveContainerEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaSubtleDefault = "hsl(200 30% 98% / 0)";
export const aliasesColorBorderInteractiveCtaSubtleHover = "hsl(200 30% 98% / 0)";
export const aliasesColorBorderInteractiveCtaSubtleFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaSubtleDisabled = "hsl(0 0% 100% / 0)";
export const aliasesColorBorderInteractiveCtaNeutralDefault = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveCtaNeutralHover = "hsl(200, 30%, 82%)";
export const aliasesColorBorderInteractiveCtaNeutralFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaNeutralDisabled = "hsl(200, 30%, 96%)";
export const aliasesColorBorderInteractiveCtaEmphasisDefault = "#001c33";
export const aliasesColorBorderInteractiveCtaEmphasisHover = "#001c33";
export const aliasesColorBorderInteractiveCtaEmphasisFocus = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorBorderInteractiveCtaEmphasisDisabled = "hsl(200 30% 70% / 0.38)";
export const aliasesColorBorderStaticComponentSubtle = "hsl(210, 20%, 92%)";
export const aliasesColorBorderStaticComponentNeutral = "hsl(210, 20%, 92%)";
export const aliasesColorBorderStaticComponentEmphasis = "hsl(210, 20%, 40%)";
export const aliasesColorBorderStaticContainerSubtle = "hsl(210, 20%, 92%)";
export const aliasesColorBorderStaticContainerNeutral = "hsl(210, 20%, 82%)";
export const aliasesColorBorderStaticContainerEmphasis = "hsl(210, 20%, 20%)";
export const aliasesColorBorderErrorSubtle = "hsl(350, 70%, 96%)";
export const aliasesColorBorderErrorNeutral = "hsl(350, 70%, 50%)";
export const aliasesColorBorderErrorEmphasis = "hsl(350, 70%, 30%)";
export const aliasesColorBorderSuccessSubtle = "hsl(150, 50%, 90%)";
export const aliasesColorBorderSuccessNeutral = "hsl(150, 50%, 50%)";
export const aliasesColorBorderSuccessEmphasis = "hsl(150, 50%, 30%)";
export const aliasesColorBorderWarningSubtle = "hsl(30, 70%, 86%)";
export const aliasesColorBorderWarningNeutral = "hsl(30, 70%, 60%)";
export const aliasesColorBorderWarningEmphasis = "hsl(30, 70%, 20%)";
export const aliasesColorBorderInfoSubtle = "hsl(270, 50%, 90%)";
export const aliasesColorBorderInfoNeutral = "hsl(270, 50%, 50%)";
export const aliasesColorBorderInfoEmphasis = "hsl(270, 50%, 20%)";
export const aliasesColorBorderLogoEmail = "#A7CBB2";
export const aliasesColorBorderLogoPlatform = "#7DCDF5";
export const aliasesColorBorderLogoNetwork = "#DCCDE0";
export const aliasesColorBorderLogoApp = "#A9E7EA";
export const aliasesColorBorderLogoData = "#F7DD7A";
export const aliasesColorTextInteractiveSubtle = "hsl(207, 100%, 30%)";
export const aliasesColorTextInteractiveNeutral = "hsl(207, 100%, 20%)";
export const aliasesColorTextInteractiveEmphasis = "#001c33";
export const aliasesColorTextInteractiveDisabled = "hsl(200 30% 50% / 0.38)";
export const aliasesColorTextInteractiveSelected = "hsl(207, 100%, 30%)";
export const aliasesColorTextInverseEmphasis = "#ffffff";
export const aliasesColorTextInverseDisabled = "hsl(0 0% 100% / 0.38)";
export const aliasesColorTextInverseNeutral = "hsl(0 0% 100% / 0.8)";
export const aliasesColorTextInverseSubtle = "hsl(0 0% 100% / 0.75)";
export const aliasesColorTextStaticSubtle = "hsl(210, 20%, 50%)";
export const aliasesColorTextStaticNeutral = "hsl(210, 20%, 30%)";
export const aliasesColorTextStaticEmphasis = "hsl(210, 20%, 10%)";
export const aliasesColorTextStaticInverse = "#ffffff";
export const aliasesColorTextError = "hsl(350, 70%, 20%)";
export const aliasesColorBgLogoEmailDefault = "#C0EFCF";
export const aliasesColorBgLogoEmailLight = "#A7CBB2";
export const aliasesColorBgLogoNetwork = "#EDE5EF";
export const aliasesColorBgLogoAppDefault = "#C9F1F3";
export const aliasesColorBgLogoAppLight = "#A9E7EA";
export const aliasesColorBgLogoData = "#FEECA8";
export const aliasesColorBgLogoTeeth = "hsl(210, 20%, 10%)";
export const aliasesColorBgLogoPlatform = "#ADE3FE";
export const aliasesColorBgSeries1Default = "hsl(202, 100%, 40%)";
export const aliasesColorBgSeries1Hover = "hsl(202, 100%, 30%)";
export const aliasesColorBgSeries1Focus = "hsl(202, 100%, 30%)";
export const aliasesColorBgSeries1Selected = "hsl(202, 100%, 30%)";
export const aliasesColorBgSeries1Transparent = "hsl(202 100% 40% / 0.5)"; // Used for map pins
export const aliasesColorBgSeries2Default = "hsl(266, 63%, 45%)";
export const aliasesColorBgSeries2Hover = "hsl(266, 63%, 35%)";
export const aliasesColorBgSeries2Focus = "hsl(266, 63%, 35%)";
export const aliasesColorBgSeries2Selected = "hsl(266, 63%, 35%)";
export const aliasesColorBgSeries2Transparent = "hsl(266 63% 45% / 0.5)";
export const aliasesColorBgSeries3Default = "hsl(301, 73%, 75%)";
export const aliasesColorBgSeries3Hover = "hsl(301, 73%, 65%)";
export const aliasesColorBgSeries3Focus = "hsl(301, 73%, 65%)";
export const aliasesColorBgSeries3Selected = "hsl(301, 73%, 65%)";
export const aliasesColorBgSeries3Transparent = "hsl(301 73% 75% / 0.5)";
export const aliasesColorBgSeries4Default = "hsl(169, 82%, 33%)";
export const aliasesColorBgSeries4Hover = "hsl(169, 82%, 23%)";
export const aliasesColorBgSeries4Focus = "hsl(169, 82%, 23%)";
export const aliasesColorBgSeries4Selected = "hsl(169, 82%, 23%)";
export const aliasesColorBgSeries4Transparent = "hsl(169 82% 33% / 0.5)";
export const aliasesColorBgSeries5Default = "hsl(346, 37%, 43%)";
export const aliasesColorBgSeries5Hover = "hsl(346, 37%, 33%)";
export const aliasesColorBgSeries5Focus = "hsl(346, 37%, 33%)";
export const aliasesColorBgSeries5Selected = "hsl(346, 37%, 33%)";
export const aliasesColorBgSeries5Transparent = "hsl(346 37% 43% / 0.5)";
export const aliasesColorBgSeries6Default = "hsl(36, 77%, 40%)";
export const aliasesColorBgSeries6Hover = "hsl(36, 77%, 30%)";
export const aliasesColorBgSeries6Focus = "hsl(36, 77%, 30%)";
export const aliasesColorBgSeries6Selected = "hsl(36, 77%, 30%)";
export const aliasesColorBgSeries6Transparent = "hsl(36 77% 40% / 0.5)";
export const aliasesColorBgSeries7Default = "hsl(151, 46%, 17%)";
export const aliasesColorBgSeries7Hover = "hsl(151, 46%, 27%)";
export const aliasesColorBgSeries7Focus = "hsl(151, 46%, 27%)";
export const aliasesColorBgSeries7Selected = "hsl(169, 82%, 23%)";
export const aliasesColorBgSeries7Transparent = "hsl(151 46% 27% / 0.5)";
export const aliasesColorBgSeries8Default = "hsl(36, 97%, 70%)";
export const aliasesColorBgSeries8Hover = "hsl(36, 97%, 60%)";
export const aliasesColorBgSeries8Focus = "hsl(36, 97%, 60%)";
export const aliasesColorBgSeries8Selected = "hsl(36, 97%, 60%)";
export const aliasesColorBgSeries8Transparent = "hsl(36 97% 70% / 0.5)";
export const aliasesColorBgStaticComponentSubtle = "#ffffff";
export const aliasesColorBgStaticComponentNeutral = "hsl(210, 20%, 90%)";
export const aliasesColorBgStaticComponentEmphasis = "hsl(210, 20%, 40%)";
export const aliasesColorBgStaticComponentHighlightText = "hsl(50, 70%, 82%)";
export const aliasesColorBgStaticContainerSubtle = "#ffffff";
export const aliasesColorBgStaticContainerNeutral = "hsl(210, 20%, 98%)";
export const aliasesColorBgStaticContainerEmphasis = "hsl(210, 20%, 20%)";
export const aliasesColorBgStaticContainerBackdrop = "hsl(210 20% 30% / 0.5)";
export const aliasesColorBgNavigationPrimary = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
export const aliasesColorBgNavigationSecondary = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
export const aliasesColorBgErrorSubtle = "hsl(350, 70%, 96%)";
export const aliasesColorBgErrorNeutral = "hsl(350, 70%, 50%)";
export const aliasesColorBgErrorEmphasis = "hsl(350, 70%, 20%)";
export const aliasesColorBgSuccessSubtle = "hsl(150, 50%, 90%)";
export const aliasesColorBgSuccessNeutral = "hsl(150, 50%, 50%)";
export const aliasesColorBgSuccessEmphasis = "hsl(150, 50%, 20%)";
export const aliasesColorBgWarningSubtle = "hsl(30, 70%, 90%)";
export const aliasesColorBgWarningNeutral = "hsl(30, 70%, 50%)";
export const aliasesColorBgWarningEmphasis = "hsl(30, 70%, 20%)";
export const aliasesColorBgInfoSubtle = "hsl(270, 50%, 90%)";
export const aliasesColorBgInfoNeutral = "hsl(270, 50%, 50%)";
export const aliasesColorBgInfoEmphasis = "hsl(270, 50%, 20%)";
export const aliasesColorBgInteractiveComponentSubtleDefault = "hsl(0 0% 100% / 0)";
export const aliasesColorBgInteractiveComponentSubtleHover = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveComponentSubtleFocus = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveComponentSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const aliasesColorBgInteractiveComponentSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveComponentSubtleDisabled = "hsl(200 30% 98% / 0)";
export const aliasesColorBgInteractiveComponentNeutralDefault = "hsl(207, 100%, 96%)";
export const aliasesColorBgInteractiveComponentNeutralHover = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveComponentNeutralFocus = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveComponentNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveComponentNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const aliasesColorBgInteractiveComponentNeutralDisabled = "hsl(207 100% 96% / 0.38)";
export const aliasesColorBgInteractiveComponentEmphasisDefault = "#001c33";
export const aliasesColorBgInteractiveComponentEmphasisHover = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveComponentEmphasisFocus = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveComponentEmphasisSelectedDefault = "#001c33";
export const aliasesColorBgInteractiveComponentEmphasisSelectedHover = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveComponentEmphasisDisabled = "hsl(207 100% 10% / 0.38)";
export const aliasesColorBgInteractiveContainerSubtleDefault = "#ffffff";
export const aliasesColorBgInteractiveContainerSubtleHover = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveContainerSubtleFocus = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveContainerSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const aliasesColorBgInteractiveContainerSubtleSelectedHover = "hsl(207, 100%, 92%)";
export const aliasesColorBgInteractiveContainerSubtleDisabled = "hsl(0 0% 100% / 0.38)";
export const aliasesColorBgInteractiveContainerNeutralDefault = "hsl(200, 30%, 96%)";
export const aliasesColorBgInteractiveContainerNeutralHover = "hsl(207, 100%, 96%)";
export const aliasesColorBgInteractiveContainerNeutralFocus = "hsl(207, 100%, 96%)";
export const aliasesColorBgInteractiveContainerNeutralSelectedDefault = "hsl(207, 100%, 92%)";
export const aliasesColorBgInteractiveContainerNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const aliasesColorBgInteractiveContainerNeutralDisabled = "hsl(200 30% 96% / 0.38)";
export const aliasesColorBgInteractiveContainerEmphasisDefault = "#001c33";
export const aliasesColorBgInteractiveContainerEmphasisHover = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveContainerEmphasisFocus = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveContainerEmphasisSelectedDefault = "#005499";
export const aliasesColorBgInteractiveContainerEmphasisSelectedHover = "#005499";
export const aliasesColorBgInteractiveContainerEmphasisDisabled = "hsl(207 100% 10% / 0.38)";
export const aliasesColorBgInteractiveCtaSubtleDefault = "hsl(207 100% 98% / 0)";
export const aliasesColorBgInteractiveCtaSubtleHover = "hsl(207 100% 92% / 0.5)";
export const aliasesColorBgInteractiveCtaSubtleFocus = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveCtaSubtleSelectedDefault = "hsl(207, 100%, 92%)";
export const aliasesColorBgInteractiveCtaSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveCtaNeutralDefault = "hsl(207, 100%, 98%)";
export const aliasesColorBgInteractiveCtaNeutralHover = "hsl(207, 100%, 92%)";
export const aliasesColorBgInteractiveCtaNeutralFocus = "hsl(207, 100%, 92%)";
export const aliasesColorBgInteractiveCtaNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const aliasesColorBgInteractiveCtaNeutralSelectedHover = "hsl(207, 100%, 88%)";
export const aliasesColorBgInteractiveCtaEmphasisDefault = "#001c33";
export const aliasesColorBgInteractiveCtaEmphasisHover = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveCtaEmphasisFocus = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveCtaEmphasisSelectedDefault = "hsl(207, 100%, 20%)";
export const aliasesColorBgInteractiveCtaEmphasisSelectedHover = "#001c33";
export const aliasesColorBgInteractiveCtaDisabled = "hsl(0 0% 100% / 0.38)";
export const aliasesColorBgPageDefault = "#ffffff";
export const aliasesColorBgPageNeutral = "hsl(210, 20%, 96%)";
export const aliasesColorIconStaticSubtle = "#ffffff";
export const aliasesColorIconStaticNeutral = "hsl(210, 20%, 90%)";
export const aliasesColorIconStaticEmphasis = "hsl(210, 20%, 40%)";
export const aliasesColorIconErrorSubtle = "hsl(350, 70%, 96%)";
export const aliasesColorIconErrorNeutral = "hsl(350, 70%, 50%)";
export const aliasesColorIconErrorEmphasis = "hsl(350, 70%, 30%)";
export const aliasesColorIconSuccessSubtle = "hsl(150, 50%, 90%)";
export const aliasesColorIconSuccessNeutral = "hsl(150, 50%, 50%)";
export const aliasesColorIconSuccessEmphasis = "hsl(150, 50%, 30%)";
export const aliasesColorIconWarningSubtle = "hsl(30, 70%, 90%)";
export const aliasesColorIconWarningNeutral = "hsl(30, 70%, 50%)";
export const aliasesColorIconWarningEmphasis = "hsl(30, 70%, 20%)";
export const aliasesColorIconInfoSubtle = "hsl(270, 50%, 90%)";
export const aliasesColorIconInfoNeutral = "hsl(270, 50%, 50%)";
export const aliasesColorIconInfoEmphasis = "hsl(270, 50%, 20%)";
export const aliasesColorIconInteractiveComponentSubtleDefault = "hsl(200, 30%, 82%)";
export const aliasesColorIconInteractiveComponentSubtleHover = "hsl(200, 30%, 70%)";
export const aliasesColorIconInteractiveComponentSubtleFocus = "hsl(200, 30%, 70%)";
export const aliasesColorIconInteractiveComponentSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentSubtleDisabled = "hsl(200 30% 82% / 0.38)";
export const aliasesColorIconInteractiveComponentNeutralDefault = "hsl(200, 30%, 50%)";
export const aliasesColorIconInteractiveComponentNeutralHover = "hsl(200, 30%, 40%)";
export const aliasesColorIconInteractiveComponentNeutralFocus = "hsl(200, 30%, 40%)";
export const aliasesColorIconInteractiveComponentNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentNeutralDisabled = "hsl(200 30% 50% / 0.38)";
export const aliasesColorIconInteractiveComponentEmphasisDefault = "#001c33";
export const aliasesColorIconInteractiveComponentEmphasisHover = "hsl(207, 100%, 20%)";
export const aliasesColorIconInteractiveComponentEmphasisFocus = "hsl(207, 100%, 20%)";
export const aliasesColorIconInteractiveComponentEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveComponentEmphasisDisabled = "hsl(200 30% 10% / 0.38)";
export const aliasesColorIconInteractiveCtaSubtleDefault = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaSubtleHover = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaSubtleFocus = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaNeutralDefault = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaNeutralHover = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaNeutralFocus = "hsl(207, 100%, 50%)";
export const aliasesColorIconInteractiveCtaEmphasisDefault = "#ffffff";
export const aliasesColorIconInteractiveCtaEmphasisHover = "#ffffff";
export const aliasesColorIconInteractiveCtaEmphasisFocus = "#ffffff";
export const aliasesColorIconInteractiveCtaDisabled = "hsl(200 30% 70% / 0.38)";
export const aliasesColorIllustrationGreen = "#7de8d6";
export const aliasesColorIllustrationBlue = "hsl(207, 100%, 40%)";
export const aliasesColorIllustrationGray = "#dbe2f0";
export const aliasesColorIllustrationDarkGray = "#3d588f";
export const aliasesColorIllustrationFushia = "#bf40bf";
export const aliasesColorIllustrationOrange = "hsl(30, 70%, 82%)";
export const aliasesColorBarracudaBlue = "hsl(207, 100%, 40%)";
export const aliasesLetterSpacingDefault = "0";
export const aliasesFontSizeMicro = "8px";
export const aliasesFontSizeLabel = "10px";
export const aliasesFontSizeCaption = "12px";
export const aliasesFontSizeDefault = "14px";
export const aliasesFontSizeH1 = "30px";
export const aliasesFontSizeH2 = "24px";
export const aliasesFontSizeH3 = "20px";
export const aliasesFontSizeH4 = "16px";
export const aliasesFontSizeDefaultSmall = "12px";
export const themes0Id = "a08f0ecdf1d566ecd1b9fdb6e63f430334c36f90";
export const themes0Name = "Barracuda";
export const themes0SelectedTokenSetsGlobals = "source";
export const themes0SelectedTokenSetsAliases = "enabled";
export const themes0SelectedTokenSetsComponentsButton = "source";
export const themes0Group = "Brand";
export const themes1Id = "1ea10838fef7047bfa8454a2fe209911101832f9";
export const themes1Name = "v1";
export const themes1SelectedTokenSetsGlobals = "enabled";
export const themes1SelectedTokenSetsAliases = "enabled";
export const themes1SelectedTokenSetsVersionV1 = "enabled";
export const themes1SelectedTokenSetsComponentsButton = "disabled";
export const themes1Group = "version";
export const metadataTokenSetOrder0 = "globals";
export const metadataTokenSetOrder1 = "aliases";
export const metadataTokenSetOrder2 = "components/button";
export const metadataTokenSetOrder3 = "version/v1";
export const avatarRadiusRound = "100px";
export const avatarSizeS = "16px";
export const avatarSizeM = "20px";
export const avatarSizeL = "24px";
export const avatarSizeXl = "28px";
export const avatarSizeXxl = "32px";
export const avatarColorBgStaticSubtle = "#ffffff";
export const avatarColorBgStaticNeutral = "hsl(210, 20%, 90%)";
export const avatarColorBgStaticEmphasis = "hsl(210, 20%, 40%)";
export const avatarColorBgInteractiveSubtleDefault = "hsl(0 0% 100% / 0)";
export const avatarColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const avatarColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const avatarColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const avatarColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const avatarColorBgInteractiveNeutralDefault = "hsl(207, 100%, 96%)";
export const avatarColorBgInteractiveNeutralHover = "hsl(207, 100%, 90%)";
export const avatarColorBgInteractiveNeutralFocus = "hsl(207, 100%, 90%)";
export const avatarColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const avatarColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const avatarColorBgInteractiveEmphasisDefault = "#001c33";
export const avatarColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const avatarColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const avatarColorBgInteractiveEmphasisSelectedDefault = "#001c33";
export const avatarColorBgInteractiveEmphasisSelectedHover = "hsl(207, 100%, 20%)";
export const avatarColorBgInteractiveDisabled = "hsl(200 30% 98% / 0)";
export const avatarColorTextStaticSubtle = "hsl(210, 20%, 30%)";
export const avatarColorTextStaticNeutral = "hsl(210, 20%, 10%)";
export const avatarColorTextStaticEmphasis = "#ffffff";
export const avatarColorTextInteractiveSubtle = "hsl(207, 100%, 30%)";
export const avatarColorTextInteractiveNeutral = "hsl(207, 100%, 20%)";
export const avatarColorTextInteractiveEmphasis = "#ffffff";
export const avatarColorTextInteractiveDisabled = "hsl(200 30% 50% / 0.38)";
export const avatarColorTextInteractiveSelected = "hsl(207, 100%, 30%)";
export const avatarColorBorderStaticSubtle = "hsl(210, 20%, 92%)";
export const avatarColorBorderStaticNeutral = "hsl(210, 20%, 92%)";
export const avatarColorBorderStaticEmphasis = "hsl(210, 20%, 40%)";
export const avatarColorBorderInteractiveSubtleDefault = "hsl(200, 30%, 82%)";
export const avatarColorBorderInteractiveSubtleHover = "hsl(200, 30%, 82%)";
export const avatarColorBorderInteractiveSubtleFocus = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveNeutralDefault = "hsl(200, 30%, 82%)";
export const avatarColorBorderInteractiveNeutralHover = "hsl(200, 30%, 60%)";
export const avatarColorBorderInteractiveNeutralFocus = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveEmphasisDefault = "#001c33";
export const avatarColorBorderInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const avatarColorBorderInteractiveEmphasisFocus = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const avatarColorBorderInteractiveDisabled = "hsl(200 30% 82% / 0.38)";
export const avatarBorderWidthDefault = "1px";
export const avatarFontFamily = "Manrope";
export const avatarFontWeight = "600";
export const avatarFontSizeS = "8px";
export const avatarFontSizeM = "12px";
export const avatarFontSizeL = "14px";
export const avatarFontSizeXl = "14px";
export const avatarFontSizeXxl = "16px";
export const avatarLetterSpacing = "0";
export const avatarTextCase = "uppercase";
export const avatarLineHeightXxl = "18px";
export const avatarLineHeightXl = "16px";
export const avatarLineHeightL = "16px";
export const avatarLineHeightM = "12px";
export const avatarLineHeightS = "8px";
export const avatarTextDecoration = "none";
export const buttonBorderWidth = "1px";
export const buttonPadding = "16px";
export const buttonSpaceBetween = "4px";
export const buttonRadius = "4px";
export const buttonHeightDefault = "36px";
export const buttonColorBgActionBarDefault = "hsl(207 100% 98% / 0)";
export const buttonColorBgActionBarHover = "hsl(207 100% 92% / 0.5)";
export const buttonColorBgActionBarFocus = "hsl(207, 100%, 98%)";
export const buttonColorBgSubtleDefault = "hsl(207 100% 98% / 0)";
export const buttonColorBgSubtleHover = "hsl(207 100% 92% / 0.5)";
export const buttonColorBgSubtleFocus = "hsl(207, 100%, 98%)";
export const buttonColorBgSubtleSelectedDefault = "hsl(207, 100%, 92%)";
export const buttonColorBgSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const buttonColorBgNeutralDefault = "hsl(207, 100%, 98%)";
export const buttonColorBgNeutralHover = "hsl(207, 100%, 92%)";
export const buttonColorBgNeutralFocus = "hsl(207, 100%, 92%)";
export const buttonColorBgNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const buttonColorBgNeutralSelectedHover = "hsl(207, 100%, 88%)";
export const buttonColorBgEmphasisDefault = "#001c33";
export const buttonColorBgEmphasisHover = "hsl(207, 100%, 20%)";
export const buttonColorBgEmphasisFocus = "hsl(207, 100%, 20%)";
export const buttonColorBgEmphasisSelectedDefault = "hsl(207, 100%, 20%)";
export const buttonColorBgEmphasisSelectedHover = "#001c33";
export const buttonColorBgDisabled = "hsl(0 0% 100% / 0.38)";
export const buttonColorTextActionBar = "#ffffff";
export const buttonColorTextSubtle = "#001c33";
export const buttonColorTextNeutral = "#001c33";
export const buttonColorTextEmphasis = "#ffffff";
export const buttonColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const buttonColorBorderActionBarDefault = "hsl(200 30% 98% / 0)";
export const buttonColorBorderActionBarHover = "hsl(200 30% 98% / 0)";
export const buttonColorBorderActionBarFocus = "hsl(207, 100%, 50%)";
export const buttonColorBorderSubtleDefault = "hsl(200 30% 98% / 0)";
export const buttonColorBorderSubtleHover = "hsl(200 30% 98% / 0)";
export const buttonColorBorderSubtleFocus = "hsl(207, 100%, 50%)";
export const buttonColorBorderSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const buttonColorBorderSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const buttonColorBorderNeutralDefault = "hsl(200, 30%, 82%)";
export const buttonColorBorderNeutralHover = "hsl(200, 30%, 82%)";
export const buttonColorBorderNeutralFocus = "hsl(207, 100%, 50%)";
export const buttonColorBorderNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const buttonColorBorderNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const buttonColorBorderEmphasisDefault = "#001c33";
export const buttonColorBorderEmphasisHover = "#001c33";
export const buttonColorBorderEmphasisFocus = "hsl(207, 100%, 50%)";
export const buttonColorBorderEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const buttonColorBorderEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const buttonColorBorderDisabled = "hsl(200 30% 70% / 0.38)";
export const buttonSplitWidth = "36px";
export const buttonFontFamily = "Manrope";
export const buttonFontWeight = "700";
export const buttonLineHeight = "14px";
export const buttonFontSize = "14px";
export const buttonLetterSpacing = "0";
export const iconButtonBorderWidth = "0px";
export const iconButtonSizeRoundM = "20px";
export const iconButtonSizeRoundInput = "36px";
export const iconButtonSizeRectangleDefaultWidth = "56px";
export const iconButtonSizeRectangleDefaultHeight = "40px";
export const iconButtonRadiusRound = "100px";
export const iconButtonRadiusRectangle = "4px";
export const iconButtonColorBgSubtleDefault = "hsl(0 0% 100% / 0)";
export const iconButtonColorBgSubtleHover = "hsl(207, 100%, 98%)";
export const iconButtonColorBgSubtleFocus = "hsl(207, 100%, 98%)";
export const iconButtonColorBgSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const iconButtonColorBgSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const iconButtonColorBgSubtleMenuOpen = "hsl(207, 100%, 90%)";
export const iconButtonColorBgDisabled = "hsl(200 30% 98% / 0)";
export const iconButtonColorBorderSubtleDefault = "hsl(200, 30%, 82%)";
export const iconButtonColorBorderSubtleHover = "hsl(200, 30%, 82%)";
export const iconButtonColorBorderSubtleFocus = "hsl(207, 100%, 50%)";
export const iconButtonColorBorderSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const iconButtonColorBorderSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const iconButtonColorBorderSubtleMenuOpen = "hsl(207, 100%, 50%)";
export const iconButtonColorBorderDisabled = "hsl(200 30% 60% / 0.38)";
export const iconButtonColorTextDefault = "hsl(210, 20%, 50%)";
export const iconButtonColorTextSelected = "hsl(207, 100%, 30%)";
export const iconButtonColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const iconButtonSpaceBetween = "4px";
export const tooltipBorderWidth = "1px";
export const tooltipRadius = "4px";
export const tooltipColorBg = "#001c33";
export const tooltipColorBorder = "hsl(200, 30%, 96%)";
export const tooltipColorText = "#ffffff";
export const tooltipFontFamily = "Manrope";
export const tooltipFontWeight = "600";
export const tooltipLineHeight = "10px";
export const tooltipFontSize = "12px";
export const tooltipLetterSpacing = "0";
export const tooltipPadding = "4px";
export const chipRadiusRound = "100px";
export const chipBorderWidth = "1px";
export const chipSizeMediumHeight = "24px";
export const chipSizeMediumPaddingRight = "8px";
export const chipSizeMediumPaddingLeft = "8px";
export const chipSizeMediumSpaceBetween = "4px";
export const chipSizeLargeHeight = "28px";
export const chipSizeLargePaddingRight = "8px";
export const chipSizeLargePaddingLeft = "8px";
export const chipSizeLargeSpaceBetween = "4px";
export const chipSizeInputHeight = "36px";
export const chipSizeInputPaddingRight = "8px";
export const chipSizeInputPaddingLeft = "8px";
export const chipSizeInputSpaceBetween = "8px";
export const chipColorBgStaticSubtle = "#ffffff";
export const chipColorBgStaticNeutralDefault = "hsl(210, 20%, 90%)";
export const chipColorBgStaticNeutralSuccess = "hsl(150, 50%, 90%)";
export const chipColorBgStaticNeutralError = "hsl(350, 70%, 96%)";
export const chipColorBgStaticNeutralWarning = "hsl(30, 70%, 90%)";
export const chipColorBgStaticNeutralInfo = "hsl(270, 50%, 90%)";
export const chipColorBgStaticEmphasisDefault = "hsl(210, 20%, 40%)";
export const chipColorBgStaticEmphasisSuccess = "hsl(150, 50%, 20%)";
export const chipColorBgStaticEmphasisError = "hsl(350, 70%, 20%)";
export const chipColorBgStaticEmphasisWarning = "hsl(30, 70%, 20%)";
export const chipColorBgStaticEmphasisInfo = "hsl(270, 50%, 20%)";
export const chipColorBgInteractiveSubtleDefault = "hsl(0 0% 100% / 0)";
export const chipColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const chipColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const chipColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const chipColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const chipColorBgInteractiveNeutralDefault = "hsl(207, 100%, 96%)";
export const chipColorBgInteractiveNeutralHover = "hsl(207, 100%, 90%)";
export const chipColorBgInteractiveNeutralFocus = "hsl(207, 100%, 90%)";
export const chipColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const chipColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const chipColorBgInteractiveEmphasisDefault = "#001c33";
export const chipColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const chipColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const chipColorBgInteractiveEmphasisSelectedDefault = "#001c33";
export const chipColorBgInteractiveEmphasisSelectedHover = "hsl(207, 100%, 20%)";
export const chipColorBgInteractiveDisabled = "hsl(200 30% 98% / 0)";
export const chipColorTextErrorSubtle = "hsl(350, 70%, 20%)";
export const chipColorTextStaticSubtle = "hsl(210, 20%, 30%)";
export const chipColorTextStaticEmphasis = "#ffffff";
export const chipColorTextStaticNeutral = "hsl(210, 20%, 10%)";
export const chipColorTextInteractiveNeutral = "hsl(207, 100%, 20%)";
export const chipColorTextInteractiveSubtle = "hsl(207, 100%, 30%)";
export const chipColorTextInteractiveEmphasis = "#ffffff";
export const chipColorTextInteractiveSelected = "hsl(207, 100%, 30%)";
export const chipColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const chipColorBorderStaticSubtle = "hsl(210, 20%, 92%)";
export const chipColorBorderStaticNeutralDefault = "hsl(210, 20%, 92%)";
export const chipColorBorderStaticNeutralError = "hsl(350, 70%, 50%)";
export const chipColorBorderStaticNeutralSuccess = "hsl(150, 50%, 50%)";
export const chipColorBorderStaticNeutralWarning = "hsl(30, 70%, 60%)";
export const chipColorBorderStaticNeutralInfo = "hsl(270, 50%, 50%)";
export const chipColorBorderStaticEmphasisDefault = "hsl(210, 20%, 40%)";
export const chipColorBorderStaticEmphasisSuccess = "hsl(150, 50%, 30%)";
export const chipColorBorderStaticEmphasisWarning = "hsl(30, 70%, 20%)";
export const chipColorBorderStaticEmphasisError = "hsl(350, 70%, 30%)";
export const chipColorBorderStaticEmphasisInfo = "hsl(270, 50%, 20%)";
export const chipColorBorderInteractiveNeutralDefault = "hsl(200, 30%, 60%)";
export const chipColorBorderInteractiveNeutralHover = "hsl(200, 30%, 60%)";
export const chipColorBorderInteractiveNeutralFocus = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveSubtleDefault = "hsl(200, 30%, 82%)";
export const chipColorBorderInteractiveSubtleHover = "hsl(200, 30%, 82%)";
export const chipColorBorderInteractiveSubtleFocus = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveEmphasisDefault = "#001c33";
export const chipColorBorderInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const chipColorBorderInteractiveEmphasisFocus = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const chipColorBorderInteractiveDisabled = "hsl(200 30% 60% / 0.38)";
export const chipFontFamily = "Manrope";
export const chipFontWeight = "600";
export const chipMFontSize = "12px";
export const chipLFontSize = "14px";
export const chipInputFontSize = "14px";
export const chipLetterSpacing = "0";
export const chipLineHeightL = "16px";
export const chipLineHeightM = "12px";
export const chipLineHeightInput = "14px";
export const iconSizeMicro = "4px";
export const iconSizeXxs = "8px";
export const iconSizeXs = "12px";
export const iconSizeS = "16px";
export const iconSizeM = "20px";
export const iconSizeL = "24px";
export const iconSizeXl = "28px";
export const iconSizeXxl = "32px";
export const iconSizeTappable = "36px";
export const iconColorStaticSubtle = "#ffffff";
export const iconColorStaticNeutral = "hsl(210, 20%, 90%)";
export const iconColorStaticEmphasis = "hsl(210, 20%, 40%)";
export const iconColorInteractiveCtaSubtleDefault = "hsl(207, 100%, 50%)";
export const iconColorInteractiveCtaNeutralDefault = "hsl(207, 100%, 50%)";
export const iconColorInteractiveCtaEmphasisDefault = "#ffffff";
export const iconColorInteractiveCtaDisabled = "hsl(200 30% 50% / 0.38)";
export const iconColorInteractiveComponentSubtleDefault = "hsl(200, 30%, 82%)";
export const iconColorInteractiveComponentSubtleHover = "hsl(200, 30%, 70%)";
export const iconColorInteractiveComponentSubtleFocus = "hsl(200, 30%, 70%)";
export const iconColorInteractiveComponentSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentSubtleDisabled = "hsl(200 30% 82% / 0.38)";
export const iconColorInteractiveComponentNeutralDefault = "hsl(200, 30%, 50%)";
export const iconColorInteractiveComponentNeutralHover = "hsl(200, 30%, 40%)";
export const iconColorInteractiveComponentNeutralFocus = "hsl(200, 30%, 40%)";
export const iconColorInteractiveComponentNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentNeutralDisabled = "hsl(200 30% 50% / 0.38)";
export const iconColorInteractiveComponentEmphasisDefault = "#001c33";
export const iconColorInteractiveComponentEmphasisHover = "hsl(207, 100%, 20%)";
export const iconColorInteractiveComponentEmphasisFocus = "hsl(207, 100%, 20%)";
export const iconColorInteractiveComponentEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const iconColorInteractiveComponentEmphasisDisabled = "hsl(200 30% 10% / 0.38)";
export const iconColorErrorNeutral = "hsl(350, 70%, 50%)";
export const iconColorErrorSubtle = "hsl(350, 70%, 96%)";
export const iconColorWarningNeutral = "hsl(30, 70%, 50%)";
export const iconColorWarningSubtle = "hsl(30, 70%, 90%)";
export const iconColorSuccessNeutral = "hsl(150, 50%, 50%)";
export const iconColorSuccessSubtle = "hsl(150, 50%, 90%)";
export const iconColorInfoNeutral = "hsl(270, 50%, 50%)";
export const iconColorInfoSubtle = "hsl(270, 50%, 90%)";
export const badgeSizeMediumRadiusRound = "100px";
export const badgeSizeMediumBorderWidth = "1px";
export const badgeSizeMediumMinHeight = "20px";
export const badgeSizeMediumPaddingRight = "4px";
export const badgeSizeMediumPaddingLeft = "4px";
export const badgeSizeSmallRadiusRound = "100px";
export const badgeSizeSmallMinHeight = "16px";
export const badgeSizeSmallPaddingRight = "4px";
export const badgeSizeSmallPaddingLeft = "4px";
export const badgeSizeInputMinHeight = "36px";
export const badgeColorBgErrorSubtle = "hsl(350, 70%, 96%)";
export const badgeColorBgStaticSubtle = "#ffffff";
export const badgeColorBgStaticNeutral = "hsl(210, 20%, 90%)";
export const badgeColorBgStaticEmphasis = "hsl(210, 20%, 40%)";
export const badgeColorBgInteractiveSubtleDefault = "hsl(0 0% 100% / 0)";
export const badgeColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const badgeColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const badgeColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const badgeColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const badgeColorBgInteractiveSubtleDisabled = "hsl(200 30% 98% / 0)";
export const badgeColorBgInteractiveNeutralDefault = "hsl(0 0% 100% / 0)";
export const badgeColorBgInteractiveNeutralHover = "hsl(207, 100%, 90%)";
export const badgeColorBgInteractiveNeutralFocus = "hsl(207, 100%, 90%)";
export const badgeColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const badgeColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const badgeColorBgInteractiveNeutralDisabled = "hsl(207 100% 96% / 0.38)";
export const badgeColorBgInteractiveEmphasisDefault = "#001c33";
export const badgeColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const badgeColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const badgeColorBgInteractiveEmphasisSelectedDefault = "#001c33";
export const badgeColorBgInteractiveEmphasisSelectedHover = "hsl(207, 100%, 20%)";
export const badgeColorBgInteractiveEmphasisDisabled = "hsl(207 100% 10% / 0.38)";
export const badgeColorTextErrorSubtle = "hsl(350, 70%, 20%)";
export const badgeColorTextStaticSubtle = "hsl(210, 20%, 30%)";
export const badgeColorTextStaticEmphasis = "#ffffff";
export const badgeColorTextInteractiveSubtle = "hsl(207, 100%, 30%)";
export const badgeColorTextInteractiveNeutral = "hsl(207, 100%, 20%)";
export const badgeColorTextInteractiveEmphasis = "#001c33";
export const badgeColorBorderErrorSubtle = "hsl(350, 70%, 96%)";
export const badgeColorBorderStaticSubtle = "hsl(210, 20%, 92%)";
export const badgeColorBorderStaticNeutral = "hsl(210, 20%, 92%)";
export const badgeColorBorderStaticEmphasis = "hsl(210, 20%, 40%)";
export const badgeColorBorderInteractiveSubtleDefault = "hsl(200, 30%, 82%)";
export const badgeColorBorderInteractiveSubtleHover = "hsl(200, 30%, 82%)";
export const badgeColorBorderInteractiveSubtleFocus = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveSubtleDisabled = "hsl(200 30% 82% / 0.38)";
export const badgeColorBorderInteractiveNeutralDefault = "hsl(200, 30%, 82%)";
export const badgeColorBorderInteractiveNeutralHover = "hsl(200, 30%, 60%)";
export const badgeColorBorderInteractiveNeutralFocus = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveNeutralDisabled = "hsl(200 30% 60% / 0.38)";
export const badgeColorBorderInteractiveEmphasisDefault = "#001c33";
export const badgeColorBorderInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const badgeColorBorderInteractiveEmphasisFocus = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const badgeColorBorderInteractiveEmphasisDisabled = "hsl(207 100% 10% / 0.38)";
export const badgeFontFamily = "Manrope";
export const badgeFontWeight = "600";
export const badgeMLineHeight = "16px";
export const badgeMFontSize = "14px";
export const badgeSFontSize = "12px";
export const badgeSLineHeight = "12px";
export const badgeLetterSpacing = "0";
export const badgeInputLineHeight = "18px";
export const badgeInputFontSize = "14px";
export const tableCellColorBgHeaderDefault = "#ffffff";
export const tableCellColorBgHeaderSorted = "hsl(210, 20%, 98%)";
export const tableCellColorBgHeaderHover = "hsl(207, 100%, 98%)";
export const tableCellColorBgHeaderError = "hsl(350, 70%, 96%)";
export const tableCellColorBgHeaderSelected = "hsl(207, 100%, 96%)";
export const tableCellColorBgRegularDefault = "#ffffff";
export const tableCellColorBgRegularSorted = "hsl(210, 20%, 98%)";
export const tableCellColorBgRegularHover = "hsl(207, 100%, 98%)";
export const tableCellColorBgRegularError = "hsl(350, 70%, 96%)";
export const tableCellColorBgRegularSelected = "hsl(207, 100%, 96%)";
export const tableCellColorBgGrouped = "hsl(210, 20%, 98%)";
export const tableCellColorBorder = "hsl(210, 20%, 92%)";
export const tableCellBorderWidthBottom = "1px";
export const tableCellDense = "4px";
export const tableCellDefault = "8px";
export const tableCellSpacious = "16px";
export const linkColorBgDefault = "hsl(207 100% 98% / 0)";
export const linkColorBgHover = "hsl(207 100% 92% / 0.5)";
export const linkColorBgFocus = "hsl(207, 100%, 98%)";
export const linkColorBgDisabled = "hsl(0 0% 100% / 0.38)";
export const linkColorTextDefault = "#001c33";
export const linkColorTextHover = "#001c33";
export const linkColorTextFocus = "#001c33";
export const linkColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const linkColorTextVisited = "#732673";
export const linkFontFamily = "Manrope";
export const linkFontWeight = "600";
export const linkLetterSpacing = "0";
export const linkLineHeightDefault = "16px";
export const linkLineHeightCaption = "12px";
export const linkFontSizeDefault = "14px";
export const linkFontSizeCaption = "12px";
export const linkTextDecorationUnderline = "underline";
export const toggleControlsColorWrapperBgUnselectedDefault = "hsl(0 0% 100% / 0)";
export const toggleControlsColorWrapperBgUnselectedHover = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgUnselectedFocus = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgUnselectedDisabled = "hsl(200 30% 98% / 0)";
export const toggleControlsColorWrapperBgSelectedDefault = "hsl(0 0% 100% / 0)";
export const toggleControlsColorWrapperBgSelectedHover = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgSelectedFocus = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgSelectedDisabled = "hsl(200 30% 98% / 0)";
export const toggleControlsColorWrapperBgIndeterminateDefault = "hsl(0 0% 100% / 0)";
export const toggleControlsColorWrapperBgIndeterminateHover = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgIndeterminateFocus = "hsl(207, 100%, 98%)";
export const toggleControlsColorWrapperBgIndeterminateDisabled = "hsl(200 30% 98% / 0)";
export const toggleControlsColorWrapperBorderUnselectedDefault = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderUnselectedHover = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderUnselectedFocus = "hsl(207, 100%, 50%)";
export const toggleControlsColorWrapperBorderUnselectedDisabled = "hsl(200 30% 82% / 0.38)";
export const toggleControlsColorWrapperBorderSelectedDefault = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderSelectedHover = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderSelectedFocus = "hsl(207, 100%, 50%)";
export const toggleControlsColorWrapperBorderSelectedDisabled = "hsl(200 30% 82% / 0.38)";
export const toggleControlsColorWrapperBorderIndeterminateDefault = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderIndeterminateHover = "hsl(200, 30%, 82%)";
export const toggleControlsColorWrapperBorderIndeterminateFocus = "hsl(207, 100%, 50%)";
export const toggleControlsColorWrapperBorderIndeterminateDisabled = "hsl(200 30% 82% / 0.38)";
export const toggleControlsColorIconBgUnselectedDefault = "#001c33";
export const toggleControlsColorIconBgUnselectedHover = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgUnselectedFocus = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgUnselectedDisabled = "hsl(207 100% 10% / 0.38)";
export const toggleControlsColorIconBgSelectedDefault = "#001c33";
export const toggleControlsColorIconBgSelectedHover = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgSelectedFocus = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgSelectedDisabled = "hsl(207 100% 10% / 0.38)";
export const toggleControlsColorIconBgIndeterminateDefault = "#001c33";
export const toggleControlsColorIconBgIndeterminateHover = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgIndeterminateFocus = "hsl(207, 100%, 20%)";
export const toggleControlsColorIconBgIndeterminateDisabled = "hsl(207 100% 10% / 0.38)";
export const toggleControlsSizeDefault = "20px";
export const toggleControlsSizeS = "16px";
export const toggleControlsPadding = "4px";
export const toggleControlsRadiusSquare = "4px";
export const toggleControlsRadiusRound = "100px";
export const toggleControlsBorderWidthWrapper = "0px";
export const skeletonColorBg = "hsl(210, 20%, 90%)";
export const skeletonColorBorder = "hsl(210, 20%, 82%)";
export const skeletonBorderWidthNone = "0px";
export const skeletonRadiusRound = "100px";
export const skeletonRadiusSharp = "4px";
export const dividerBorderWidth = "1px";
export const dividerColor = "hsl(210, 20%, 92%)";
export const dialogSizeSWidth = "376px";
export const dialogSizeMWidth = "576px";
export const dialogSizeLWidth = "776px";
export const dialogSizeMobileWidth = "300px";
export const dialogBorderWidth = "0px";
export const dialogRadius = "4px";
export const dialogColorBgDefault = "#ffffff";
export const dialogColorBorderDefault = "hsl(210, 20%, 92%)";
export const dialogPaddingDefault = "16px";
export const dialogPaddingSpacious = "24px";
export const dialogPaddingDense = "8px";
export const headerFontFamily = "Manrope";
export const headerFontWeight = "400";
export const headerLineHeight = "26px";
export const headerFontSize = "24px";
export const headerLetterSpacing = "0";
export const alertBoxShadowInline = "0 0 0 0 hsl(200, 30%, 86%)";
export const alertBoxShadowFloating = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const alertBorderWidth = "1px";
export const alertRadius = "4px";
export const alertPadding = "16px";
export const alertSpaceBetween = "8px";
export const alertColorBgErrorNeutral = "hsl(350, 70%, 96%)";
export const alertColorBgWarningNeutral = "hsl(30, 70%, 90%)";
export const alertColorBgSuccessNeutral = "hsl(150, 50%, 90%)";
export const alertColorBgInfoNeutral = "hsl(270, 50%, 90%)";
export const alertColorBgInfoEmphasis = "hsl(270, 50%, 20%)";
export const alertColorBorderErrorNeutral = "hsl(350, 70%, 50%)";
export const alertColorBorderWarningNeutral = "hsl(30, 70%, 60%)";
export const alertColorBorderSuccessNeutral = "hsl(150, 50%, 50%)";
export const alertColorBorderInfoNeutral = "hsl(270, 50%, 50%)";
export const alertColorBorderInfoEmphasis = "hsl(270, 50%, 20%)";
export const alertColorTextNeutral = "hsl(210, 20%, 10%)";
export const alertColorTextEmphasis = "#ffffff";
export const alertColorTextErrorNeutral = "hsl(350, 70%, 20%)";
export const alertFontFamily = "Manrope";
export const alertBodyFontWeight = "400";
export const alertBodyLineHeight = "16px";
export const alertBodyFontSize = "14px";
export const alertTitleFontWeight = "700";
export const alertTitleLineHeight = "18px";
export const alertTitleFontSize = "16px";
export const alertLetterSpacing = "0";
export const switchKnobColorBgSelectedDefault = "#001c33";
export const switchKnobColorBgSelectedHover = "hsl(207, 100%, 20%)";
export const switchKnobColorBgSelectedDisabled = "hsl(207 100% 10% / 0.38)";
export const switchKnobColorBgUnselectedDefault = "#001c33";
export const switchKnobColorBgUnselectedHover = "hsl(207, 100%, 20%)";
export const switchKnobColorBgUnselectedDisabled = "hsl(207 100% 10% / 0.38)";
export const switchKnobColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const switchKnobColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const switchKnobColorBorderSelectedDisabled = "hsl(207 100% 10% / 0.38)";
export const switchKnobColorBorderUnselectedDefault = "#001c33";
export const switchKnobColorBorderUnselectedHover = "hsl(207, 100%, 20%)";
export const switchKnobColorBorderUnselectedDisabled = "hsl(207 100% 10% / 0.38)";
export const switchKnobBorderWidth = "0px";
export const switchKnobRadius = "100px";
export const switchKnobSizeM = "16px";
export const switchTrackColorBgSelectedDefault = "hsl(207, 100%, 90%)";
export const switchTrackColorBgSelectedHover = "hsl(207, 100%, 86%)";
export const switchTrackColorBgSelectedDisabled = "hsl(207 100% 96% / 0.38)";
export const switchTrackColorBgUnselectedDefault = "hsl(207, 100%, 96%)";
export const switchTrackColorBgUnselectedHover = "hsl(207, 100%, 90%)";
export const switchTrackColorBgUnselectedDisabled = "hsl(207 100% 96% / 0.38)";
export const switchTrackColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const switchTrackColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const switchTrackColorBorderSelectedDisabled = "hsl(200 30% 60% / 0.38)";
export const switchTrackColorBorderUnselectedDefault = "hsl(200, 30%, 60%)";
export const switchTrackColorBorderUnselectedHover = "hsl(200, 30%, 60%)";
export const switchTrackColorBorderUnselectedDisabled = "hsl(200 30% 60% / 0.38)";
export const switchTrackBorderWidth = "1px";
export const switchTrackRadius = "100px";
export const switchTrackSizeMMinWidth = "32px";
export const switchTrackSizeMMinHeight = "20px";
export const menuItemColorBgDefault = "hsl(0 0% 100% / 0)";
export const menuItemColorBgHover = "hsl(207, 100%, 98%)";
export const menuItemColorBgFocus = "hsl(207, 100%, 98%)";
export const menuItemColorBgSelectedDefault = "hsl(207, 100%, 96%)";
export const menuItemColorBgSelectedHover = "hsl(207, 100%, 90%)";
export const menuItemColorBgDisabled = "hsl(200 30% 98% / 0)";
export const menuItemColorBorderDefault = "hsl(200, 30%, 82%)";
export const menuItemColorBorderHover = "hsl(200, 30%, 82%)";
export const menuItemColorBorderFocus = "hsl(207, 100%, 50%)";
export const menuItemColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const menuItemColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const menuItemColorBorderDisabled = "hsl(200 30% 82% / 0.38)";
export const menuItemColorTextDefault = "hsl(207, 100%, 20%)";
export const menuItemColorTextHover = "hsl(207, 100%, 20%)";
export const menuItemColorTextFocus = "hsl(207, 100%, 20%)";
export const menuItemColorTextSelected = "hsl(207, 100%, 30%)";
export const menuItemColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const menuItemBorderWidth = "0px";
export const menuItemRadius = "4px";
export const menuItemPadding = "8px";
export const menuItemFontFamily = "Manrope";
export const menuItemFontWeightDefault = "700";
export const menuItemFontWeightNested = "400";
export const menuItemLineHeight = "16px";
export const menuItemFontSize = "14px";
export const menuItemLetterSpacing = "0";
export const menuColorBg = "#ffffff";
export const menuColorBorder = "hsl(210, 20%, 92%)";
export const menuBorderWidth = "0px";
export const menuRadius = "4px";
export const menuPadding = "8px";
export const menuSpaceBetween = "4px";
export const menuBoxShadow = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const textfieldColorBgDefault = "hsl(0 0% 100% / 0)";
export const textfieldColorBgHover = "hsl(0 0% 100% / 0)";
export const textfieldColorBgFocus = "hsl(0 0% 100% / 0)";
export const textfieldColorBgDisabled = "hsl(200 30% 98% / 0)";
export const textfieldColorBgError = "hsl(0 0% 100% / 0)";
export const textfieldColorBorderDefault = "hsl(200, 30%, 60%)";
export const textfieldColorBorderHover = "hsl(200, 30%, 60%)";
export const textfieldColorBorderFocus = "hsl(207, 100%, 50%)";
export const textfieldColorBorderDisabled = "hsl(200 30% 60% / 0.38)";
export const textfieldColorBorderError = "hsl(350, 70%, 50%)";
export const textfieldColorTextEnteredDefault = "hsl(210, 20%, 10%)";
export const textfieldColorTextEnteredDisabled = "hsl(200 30% 50% / 0.38)";
export const textfieldColorTextLabelDefault = "hsl(210, 20%, 30%)";
export const textfieldColorTextLabelDisabled = "hsl(200 30% 50% / 0.38)";
export const textfieldColorTextLabelError = "hsl(350, 70%, 20%)";
export const textfieldColorTextPlaceholderDefault = "hsl(210, 20%, 50%)";
export const textfieldColorTextPlaceholderDisabled = "hsl(200 30% 50% / 0.38)";
export const textfieldColorTextHelperTextDefault = "hsl(210, 20%, 30%)";
export const textfieldColorTextHelperTextDisabled = "hsl(200 30% 50% / 0.38)";
export const textfieldColorTextHelperTextError = "hsl(350, 70%, 20%)";
export const textfieldPadding = "8px";
export const textfieldBorderWidth = "1px";
export const textfieldSpaceBetween = "8px";
export const textfieldFontFamily = "Manrope";
export const textfieldLineHeight = "18px";
export const textfieldFontWeight = "400";
export const textfieldFontSize = "14px";
export const textfieldLetterSpacing = "0";
export const textfieldRadius = "4px";
export const helpTextFontFamily = "Manrope";
export const helpTextFontWeight = "600";
export const helpTextLineHeight = "12px";
export const helpTextFontSize = "12px";
export const helpTextLetterSpacing = "0";
export const minHeightDefault = "36px";
export const labelColorBgSubtle = "#ffffff";
export const labelColorBgNeutral = "hsl(210, 20%, 98%)";
export const labelColorText = "hsl(210, 20%, 30%)";
export const labelPadding = "4px";
export const progressContainerColorBg = "hsl(210, 20%, 90%)";
export const progressContainerColorBorder = "hsl(210, 20%, 92%)";
export const progressFillColorBgDefault = "hsl(210, 20%, 40%)";
export const progressFillColorBgError = "hsl(350, 70%, 50%)";
export const progressFillColorBorderDefault = "hsl(210, 20%, 40%)";
export const progressFillColorBorderError = "hsl(350, 70%, 50%)";
export const linearContainerBorderWidth = "0px";
export const linearContainerRadius = "100px";
export const linearFillBorderWidth = "0px";
export const linearFillRadius = "100px";
export const linearSizeSMinHeight = "4px";
export const circularSizeS = "16px";
export const circularSizeM = "20px";
export const circularSizeL = "24px";
export const circularSizeXl = "28px";
export const sparklineSizeLargeMinHeight = "24px";
export const sparklineSizeLargeMinWidth = "176px";
export const sparklineSizeMediumMinHeight = "24px";
export const sparklineSizeMediumMinWidth = "68px";
export const sparklineLineColor = "hsl(210, 20%, 40%)";
export const sparklineLineBorderWidth = "1px";
export const paginationSpaceBetween = "8px";
export const paginationPadding = "8px";
export const paginationColorBgDefault = "hsl(0 0% 100% / 0)";
export const paginationColorBgFilled = "#ffffff";
export const paginationColorBorderDefault = "hsl(210 20% 92% / 0)";
export const paginationColorBorderBorderTop = "hsl(210, 20%, 92%)";
export const paginationBorderWidthTop = "1px";
export const tabRadius = "0px";
export const tabColorBgDefaultDefault = "hsl(0 0% 100% / 0)";
export const tabColorBgDefaultHover = "hsl(207, 100%, 98%)";
export const tabColorBgDefaultFocus = "hsl(207, 100%, 98%)";
export const tabColorBgSelectedDefault = "hsl(207, 100%, 96%)";
export const tabColorBgSelectedHover = "hsl(207, 100%, 90%)";
export const tabColorBgSelectedFocus = "hsl(207, 100%, 98%)";
export const tabColorBorderDefaultDefault = "hsl(200, 30%, 82%)";
export const tabColorBorderDefaultHover = "hsl(200, 30%, 82%)";
export const tabColorBorderDefaultFocus = "hsl(207, 100%, 50%)";
export const tabColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const tabColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const tabColorBorderSelectedFocus = "hsl(207, 100%, 50%)";
export const tabColorTextDefault = "hsl(207, 100%, 20%)";
export const tabColorTextSelected = "hsl(207, 100%, 30%)";
export const tabPadding = "8px";
export const tabSpaceBetween = "8px";
export const tabBorderWidthHorizontalDefaultBottom = "0px";
export const tabBorderWidthHorizontalDefaultTop = "0px";
export const tabBorderWidthHorizontalDefaultRight = "0px";
export const tabBorderWidthHorizontalDefaultLeft = "0px";
export const tabBorderWidthHorizontalSelectedBottom = "2px";
export const tabBorderWidthHorizontalSelectedTop = "0px";
export const tabBorderWidthHorizontalSelectedRight = "0px";
export const tabBorderWidthHorizontalSelectedLeft = "0px";
export const tabBorderWidthVerticalDefaultBottom = "0px";
export const tabBorderWidthVerticalDefaultTop = "0px";
export const tabBorderWidthVerticalDefaultRight = "0px";
export const tabBorderWidthVerticalDefaultLeft = "0px";
export const tabBorderWidthVerticalSelectedBottom = "0px";
export const tabBorderWidthVerticalSelectedTop = "0px";
export const tabBorderWidthVerticalSelectedRight = "2px";
export const tabBorderWidthVerticalSelectedLeft = "0px";
export const tabFontFamily = "Manrope";
export const tabFontWeight = "700";
export const tabFontSize = "12px";
export const tabLetterSpacing = "0";
export const datawordMinHeight = "4px";
export const datawordMinWidth = "12px";
export const datawordSpaceBetween = "4px";
export const datawordColorUnfilledBg = "hsl(210, 20%, 90%)";
export const datawordColorFilledBg = "hsl(210, 20%, 40%)";
export const selectContainerlessColorBorderError = "hsl(350, 70%, 96%)";
export const selectContainerlessColorBorderDefault = "hsl(200, 30%, 82%)";
export const selectContainerlessColorBorderHover = "hsl(200, 30%, 82%)";
export const selectContainerlessColorBorderFocus = "hsl(207, 100%, 50%)";
export const selectContainerlessColorBorderDisabled = "hsl(200 30% 82% / 0.38)";
export const selectContainerlessColorBgError = "hsl(350, 70%, 96%)";
export const selectContainerlessColorBgDefault = "hsl(0 0% 100% / 0)";
export const selectContainerlessColorBgHover = "hsl(207, 100%, 98%)";
export const selectContainerlessColorBgFocus = "hsl(207, 100%, 98%)";
export const selectContainerlessColorBgDisabled = "hsl(200 30% 98% / 0)";
export const selectContainerlessColorTextError = "hsl(350, 70%, 20%)";
export const selectContainerlessColorTextDefault = "hsl(207, 100%, 20%)";
export const selectContainerlessColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const selectContainerlessRadius = "4px";
export const selectContainerlessBorderWidth = "0px";
export const selectContainerlessPadding = "8px";
export const selectContainerlessSpaceBetween = "4px";
export const datepickerDayColorBgDefault = "hsl(0 0% 100% / 0)";
export const datepickerDayColorBgHover = "hsl(207, 100%, 98%)";
export const datepickerDayColorBgSelectedDefault = "hsl(207, 100%, 96%)";
export const datepickerDayColorBgSelectedHover = "hsl(207, 100%, 90%)";
export const datepickerDayColorBgDisabled = "hsl(200 30% 98% / 0)";
export const datepickerDayColorBgStartEndDefault = "#001c33";
export const datepickerDayColorBgStartEndHover = "hsl(207, 100%, 20%)";
export const datepickerDayColorBorderDefault = "hsl(200, 30%, 82%)";
export const datepickerDayColorBorderHover = "hsl(200, 30%, 82%)";
export const datepickerDayColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const datepickerDayColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const datepickerDayColorBorderDisabled = "hsl(200 30% 82% / 0.38)";
export const datepickerDayColorBorderStartEndDefault = "hsl(207, 100%, 50%)";
export const datepickerDayColorBorderStartEndHover = "hsl(207, 100%, 50%)";
export const datepickerDayColorTextDefault = "hsl(210, 20%, 10%)";
export const datepickerDayColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const datepickerDayColorTextStartEnd = "#ffffff";
export const datepickerDayColorTextSelected = "hsl(207, 100%, 30%)";
export const datepickerDayBorderWidthSelected = "1px";
export const datepickerDayBorderWidthDefault = "0px";
export const datepickerDaySize = "36px";
export const datepickerDayDefault = "0px";
export const datepickerDaySelected = "100px";
export const datepickerDayFontWeight = "600";
export const datepickerDayFontSize = "12px";
export const datepickerContainerBorderWidth = "0px";
export const datepickerContainerRadius = "4px";
export const datepickerContainerPadding = "16px";
export const datepickerContainerSpaceBetween = "8px";
export const datepickerContainerColorBg = "#ffffff";
export const datepickerContainerColorBorder = "hsl(210, 20%, 92%)";
export const datepickerContainerElevationFloating = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const datepickerTimeColorBgDefault = "hsl(0 0% 100% / 0)";
export const datepickerTimeColorBgHover = "hsl(207, 100%, 98%)";
export const datepickerTimeColorBgSelectedDefault = "hsl(207, 100%, 96%)";
export const datepickerTimeColorBgSelectedHover = "hsl(207, 100%, 90%)";
export const datepickerTimeColorBgDisabled = "hsl(200 30% 98% / 0)";
export const datepickerTimeColorBorderDefault = "hsl(200, 30%, 82%)";
export const datepickerTimeColorBorderHover = "hsl(200, 30%, 82%)";
export const datepickerTimeColorBorderSelectedDefault = "hsl(207, 100%, 50%)";
export const datepickerTimeColorBorderSelectedHover = "hsl(207, 100%, 50%)";
export const datepickerTimeColorBorderDisabled = "hsl(200 30% 82% / 0.38)";
export const datepickerTimeColorTextDefault = "hsl(210, 20%, 10%)";
export const datepickerTimeColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const datepickerTimeColorTextStartEnd = "#ffffff";
export const datepickerTimeColorTextSelected = "hsl(207, 100%, 30%)";
export const datepickerTimeDefault = "0px";
export const datepickerTimeBorderWidthSelected = "0px";
export const datepickerTimeBorderWidthDefault = "0px";
export const datepickerTimeFontSize = "14px";
export const datepickerTimeFontWeight = "400";
export const datepickerTimeSpaceBetween = "4px";
export const datepickerTimePadding = "4px";
export const datepickerFontFamily = "Manrope";
export const navigationAccountSwitcherBorderWidthDefault = "1px";
export const navigationAccountSwitcherBorderWidthTop = "0px";
export const navigationAccountSwitcherBorderWidthFocus = "2px";
export const navigationAccountSwitcherColorBgDefault = "hsl(0 0% 100% / 0)";
export const navigationAccountSwitcherColorBgHover = "hsl(207, 100%, 98%)";
export const navigationAccountSwitcherColorBgSelected = "hsl(207, 100%, 96%)";
export const navigationAccountSwitcherColorBgDisabled = "hsl(200 30% 98% / 0)";
export const navigationAccountSwitcherColorBgFocus = "hsl(207, 100%, 98%)";
export const navigationAccountSwitcherColorBorderDefault = "hsl(200, 30%, 82%)";
export const navigationAccountSwitcherColorBorderHover = "hsl(200, 30%, 82%)";
export const navigationAccountSwitcherColorBorderSelected = "hsl(207, 100%, 50%)";
export const navigationAccountSwitcherColorBorderDisabled = "hsl(200 30% 82% / 0.38)";
export const navigationAccountSwitcherColorBorderFocus = "hsl(207, 100%, 50%)";
export const navigationAccountSwitcherColorTextDefault = "hsl(207, 100%, 20%)";
export const navigationAccountSwitcherColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const navigationAccountSwitcherColorTextSelected = "hsl(207, 100%, 30%)";
export const navigationAccountSwitcherRadiusBottom = "4px";
export const navigationAccountSwitcherRadiusTop = "0px";
export const navigationAccountSwitcherPadding = "8px";
export const navigationAccountSwitcherFontFamily = "Manrope";
export const navigationAccountSwitcherFontWeight = "600";
export const navigationAccountSwitcherLineHeight = "12px";
export const navigationAccountSwitcherFontSize = "12px";
export const navigationAccountSwitcherLetterspacing = "0";
export const navigationNavContainerPrimaryColorBg = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
export const navigationNavContainerPrimaryColorBorder = "hsl(210, 20%, 92%)";
export const navigationNavContainerPrimaryBorderWidth = "1px";
export const navigationNavContainerPrimaryRadius = "0px";
export const navigationNavContainerPrimaryWidth = "70px";
export const navigationNavContainerPrimaryPadding = "8px";
export const navigationNavContainerPrimarySpaceBetween = "8px";
export const navigationNavContainerSecondaryColorBg = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
export const navigationNavContainerSecondaryColorBorder = "hsl(210, 20%, 92%)";
export const navigationNavContainerSecondaryBorderWidth = "1px";
export const navigationNavContainerSecondaryRadius = "0px";
export const navigationNavContainerSecondaryMinWidth = "276px";
export const navigationNavContainerSecondaryPadding = "8px";
export const navigationNavContainerSecondarySpaceBetween = "8px";
export const chartsBarWidth = "16px";
export const chartsSeries1Range10 = "hsl(202 100% 40% / 0.1)";
export const chartsSeries1Range20 = "hsl(202 100% 40% / 0.2)";
export const chartsSeries1Range30 = "hsl(202 100% 40% / 0.3)";
export const chartsSeries1Range40 = "hsl(202 100% 40% / 0.4)";
export const chartsSeries1Range50 = "hsl(202 100% 40% / 0.5)";
export const chartsSeries1Range60 = "hsl(202 100% 40% / 0.6)";
export const chartsSeries1Range70 = "hsl(202 100% 40% / 0.7)";
export const chartsSeries1Range80 = "hsl(202 100% 40% / 0.8)";
export const chartsSeries1Range90 = "hsl(202 100% 40% / 0.9)";
export const chartsSeries1Range100 = "hsl(202, 100%, 40%)";
export const numberColorBgStaticSubtle = "#ffffff";
export const numberColorBgStaticNeutral = "hsl(210, 20%, 90%)";
export const numberColorBgStaticEmphasis = "hsl(210, 20%, 40%)";
export const numberColorBgInteractiveSubtleDefault = "hsl(0 0% 100% / 0)";
export const numberColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const numberColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const numberColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const numberColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 90%)";
export const numberColorBgInteractiveNeutralDefault = "hsl(207, 100%, 96%)";
export const numberColorBgInteractiveNeutralHover = "hsl(207, 100%, 90%)";
export const numberColorBgInteractiveNeutralFocus = "hsl(207, 100%, 90%)";
export const numberColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 90%)";
export const numberColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const numberColorBgInteractiveEmphasisDefault = "#001c33";
export const numberColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const numberColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const numberColorBgInteractiveEmphasisSelectedDefault = "#001c33";
export const numberColorBgInteractiveEmphasisSelectedHover = "hsl(207, 100%, 20%)";
export const numberColorBgErrorSubtle = "hsl(350, 70%, 96%)";
export const numberColorBorderStaticSubtle = "hsl(210, 20%, 92%)";
export const numberColorBorderStaticNeutral = "hsl(210, 20%, 92%)";
export const numberColorBorderStaticEmphasis = "hsl(210, 20%, 40%)";
export const numberColorBorderInteractiveSubtleDefault = "hsl(200, 30%, 82%)";
export const numberColorBorderInteractiveSubtleHover = "hsl(200, 30%, 82%)";
export const numberColorBorderInteractiveSubtleFocus = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveNeutralDefault = "hsl(200, 30%, 60%)";
export const numberColorBorderInteractiveNeutralHover = "hsl(200, 30%, 60%)";
export const numberColorBorderInteractiveNeutralFocus = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveEmphasisDefault = "#001c33";
export const numberColorBorderInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const numberColorBorderInteractiveEmphasisFocus = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const numberColorBorderInteractiveEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const numberColorTextStaticSubtle = "hsl(210, 20%, 30%)";
export const numberColorTextStaticNeutral = "hsl(210, 20%, 10%)";
export const numberColorTextStaticEmphasis = "#ffffff";
export const numberColorTextInteractiveSubtle = "hsl(207, 100%, 30%)";
export const numberColorTextError = "hsl(350, 70%, 20%)";
export const numberBorderRadiusDefault = "100px";
export const numberBorderRadiusRound = "100px";
export const numberBorderWidthDefault = "0px";
export const numberBorderWidthOutlined = "1px";
export const numberFontFamily = "Manrope";
export const numberFontWeight = "600";
export const numberLetterSpacing = "0";
export const numberFontSizeMedium = "12px";
export const numberFontSizeSmall = "12px";
export const numberFontSizeInput = "14px";
export const numberLineHeightInput = "16px";
export const numberLineHeightSmall = "12px";
export const numberLineHeightMedium = "12px";
export const numberHeightS = "16px";
export const numberHeightM = "20px";
export const numberHeightInput = "36px";
export const numberPaddingS = "4px";
export const numberPaddingM = "4px";
export const numberPaddingInput = "8px";
export const numberMinWidthS = "16px";
export const numberMinWidthM = "20px";
export const numberMinWidthInput = "36px";
export const stepperSpaceBetween = "4px";
export const stepperPadding = "4px";
export const scrollbarSize = "4px";
export const scrollbarKnobColorBg = "#001c33";
export const scrollbarBorderRadius = "100px";
export const scrollbarContainerColorBg = "#ffffff";
export const scrollbarSpacePadding = "4px";
export const listItemColorBgStaticSubtle = "#ffffff";
export const listItemColorBgStaticNeutral = "hsl(210, 20%, 98%)";
export const listItemColorBgStaticEmphasis = "hsl(210, 20%, 20%)";
export const listItemColorBgInteractiveSubtleDefault = "#ffffff";
export const listItemColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const listItemColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const listItemColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const listItemColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 92%)";
export const listItemColorBgInteractiveNeutralDefault = "hsl(200, 30%, 96%)";
export const listItemColorBgInteractiveNeutralHover = "hsl(207, 100%, 96%)";
export const listItemColorBgInteractiveNeutralFocus = "hsl(207, 100%, 96%)";
export const listItemColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 92%)";
export const listItemColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const listItemColorBgInteractiveEmphasisDefault = "#001c33";
export const listItemColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const listItemColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const listItemColorBgInteractiveEmphasisSelectedDefault = "#005499";
export const listItemColorBgInteractiveEmphasisSelectedHover = "#005499";
export const listItemColorBgInteractiveDisabled = "hsl(0 0% 100% / 0.38)";
export const listItemColorBorderStaticDefault = "hsl(210 20% 92% / 0)";
export const listItemColorBorderStaticBottomborderDefault = "hsl(210, 20%, 92%)";
export const listItemColorBorderStaticBottomborderInverse = "hsl(210, 20%, 20%)";
export const listItemColorBorderInteractiveSelected = "hsl(207, 100%, 50%)";
export const listItemColorBorderInteractiveDefault = "hsl(200, 30%, 96%)";
export const listItemColorTextStatic = "hsl(210, 20%, 10%)";
export const listItemColorTextInteractive = "hsl(207, 100%, 20%)";
export const listItemColorTextInverse = "#ffffff";
export const listItemColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const listItemColorTextSelected = "hsl(207, 100%, 30%)";
export const listItemBorderWidthBottomSeparated = "1px";
export const listItemBorderWidthBottomDefault = "0px";
export const listItemHeightS = "36px";
export const listItemHeightM = "44px";
export const listItemHeightL = "56px";
export const listItemSpaceDense = "8px";
export const listItemSpaceDefault = "16px";
export const listItemSpaceSpacious = "24px";
export const listItemRadiusDefault = "0px";
export const popoverWidthM = "276px";
export const popoverWidthL = "376px";
export const cardColorBgInteractiveSubtleDefault = "#ffffff";
export const cardColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const cardColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const cardColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const cardColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 92%)";
export const cardColorBgInteractiveNeutralDefault = "hsl(200, 30%, 96%)";
export const cardColorBgInteractiveNeutralHover = "hsl(207, 100%, 96%)";
export const cardColorBgInteractiveNeutralFocus = "hsl(207, 100%, 96%)";
export const cardColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 92%)";
export const cardColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const cardColorBgInteractiveDisabled = "hsl(0 0% 100% / 0.38)";
export const cardColorBgInteractiveEmphasisDefault = "#001c33";
export const cardColorBgInteractiveEmphasisHover = "hsl(207, 100%, 20%)";
export const cardColorBgInteractiveEmphasisFocus = "hsl(207, 100%, 20%)";
export const cardColorBgInteractiveEmphasisSelectedDefault = "#005499";
export const cardColorBgInteractiveEmphasisSelectedHover = "#005499";
export const cardColorBgStaticSubtle = "#ffffff";
export const cardColorBgStaticNeutral = "hsl(210, 20%, 98%)";
export const cardColorBgStaticEmphasis = "hsl(210, 20%, 20%)";
export const cardColorBorderInteractiveEmphasisDefault = "hsl(200, 30%, 60%)";
export const cardColorBorderInteractiveEmphasisHover = "hsl(200, 30%, 60%)";
export const cardColorBorderInteractiveEmphasisFocus = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveEmphasisSelectedDefault = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveEmphasisSelectedHover = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveSubtleDefault = "hsl(200, 30%, 96%)";
export const cardColorBorderInteractiveSubtleHover = "hsl(200, 30%, 96%)";
export const cardColorBorderInteractiveSubtleFocus = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveSubtleSelectedDefault = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveSubtleSelectedHover = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveNeutralDefault = "hsl(200, 30%, 82%)";
export const cardColorBorderInteractiveNeutralHover = "hsl(200, 30%, 82%)";
export const cardColorBorderInteractiveNeutralFocus = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveNeutralSelectedDefault = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveNeutralSelectedHover = "hsl(207, 100%, 50%)";
export const cardColorBorderInteractiveDisabled = "hsl(200 30% 82% / 0.38)";
export const cardColorBorderStaticSubtle = "hsl(210, 20%, 92%)";
export const cardColorBorderStaticNeutral = "hsl(210, 20%, 82%)";
export const cardColorBorderStaticEmphasis = "hsl(210, 20%, 20%)";
export const cardSpaceDense = "8px";
export const cardSpaceDefault = "16px";
export const cardSpaceSpacious = "24px";
export const cardBorderWidthDefault = "1px";
export const cardBorderWidthNone = "0px";
export const cardBorderRadiusDefault = "4px";
export const cardBorderRadiusSharp = "2px";
export const cardBorderRadiusRound = "100px";
export const cardBoxShadowDefault = "0 0 0 0 hsl(200, 30%, 86%)";
export const cardBoxShadowFloating = "0 12px 24px 0 rgba(0,0,0,0.2)";
export const treeItemColorBgInteractiveSubtleDefault = "#ffffff";
export const treeItemColorBgInteractiveSubtleHover = "hsl(207, 100%, 98%)";
export const treeItemColorBgInteractiveSubtleFocus = "hsl(207, 100%, 98%)";
export const treeItemColorBgInteractiveSubtleSelectedDefault = "hsl(207, 100%, 96%)";
export const treeItemColorBgInteractiveSubtleSelectedHover = "hsl(207, 100%, 92%)";
export const treeItemColorBgInteractiveNeutralDefault = "hsl(200, 30%, 96%)";
export const treeItemColorBgInteractiveNeutralHover = "hsl(207, 100%, 96%)";
export const treeItemColorBgInteractiveNeutralFocus = "hsl(207, 100%, 96%)";
export const treeItemColorBgInteractiveNeutralSelectedDefault = "hsl(207, 100%, 92%)";
export const treeItemColorBgInteractiveNeutralSelectedHover = "hsl(207, 100%, 86%)";
export const treeItemColorBgInteractiveDisabled = "hsl(0 0% 100% / 0.38)";
export const treeItemColorBorderDefault = "hsl(210, 20%, 92%)";
export const treeItemColorBorderSelected = "hsl(207, 100%, 50%)";
export const treeItemColorTextStatic = "hsl(210, 20%, 10%)";
export const treeItemColorTextDisabled = "hsl(200 30% 50% / 0.38)";
export const treeItemSpaceDense = "8px";
export const treeItemSpaceDefault = "16px";
export const treeItemSpaceSpacious = "24px";
export const treeItemBorderWidthBottom = "1px";
export const treeItemBorderWidthDefault = "0px";
//# sourceMappingURL=all_cudaLight_default.js.map